import React from 'react';
import Styles from './MyClimb.module.css';
import { Link } from 'react-router-dom';
const PrivacyPolicy = () => {
  return (
    <div className={Styles.PrivacyPolicy}>
      <div className={Styles.PrivacyPolicyContent}>
        <section>
          <h1>Midlands Youth Climbing Series (MYCS) Booking</h1>
          <small>
            MYCS 2025, Round 5, 06 Apr 2025, 08:30 @ Nottingham Climbing Centre
          </small>
        </section>
        <section>
          <h2>Boys Booking (AM)</h2>
          <Link
            style={{ color: 'blue' }}
            to='https://app.rockgympro.com/b/?&bo=0a707c6f02834e9c81d3c2eb70d0fd40'
          >
            Book Here!
          </Link>
          <br />
          <h2>Girls Booking (PM)</h2>
          <Link
            style={{ color: 'blue' }}
            to='https://app.rockgympro.com/b/?&bo=c3bd3b2e053545ceaafe86b03fa35eea'
          >
            Book Here!
          </Link>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
